import A11yDialog from 'a11y-dialog';
import Cookies from 'js-cookie';
import isbot from 'isbot';

// var materialsRegion = 'en';
// if (Cookies.get('nova_materials_region') !== 'undefined' && Cookies.get('nova_materials_region').length) {
//   materialsRegion = Cookies.get('nova_materials_region');
// }

// document.querySelectorAll('[data-action="setMaterialsRegion"]').forEach(el => {
  
//   el.addEventListener('click', () => {
    
//     // set default site cookie
//     let cookieValue = el.getAttribute('data-id');
//     Cookies.set('nova_materials_region', cookieValue, { expires: 1 });
//     materialsRegion = cookieValue;

//   });
  
// });

const materialsDialog = document.getElementById('novaEyeMarketingMaterialsRegion');

if (materialsDialog) {
  
  const dialog = new A11yDialog(materialsDialog, document.getElementById('main'));

  function init() {
    if (!isbot(navigator.userAgent)) {
      if (Cookies.get('novaEyeMarketingMaterialsRegion') == undefined) {
        dialog.show();
      }
    }
  }

  init();

  document.querySelectorAll('[data-action="changeMaterialsRegion"]').forEach(el => {
    
    el.addEventListener('click', () => {
      dialog.show();

    });
    
  });

}


$(function(){
  
  var $materialsGroup = $('#form-group-materials');
  
  $materialsGroup.removeClass('l_placeholder');
  $materialsGroup.find('textarea').hide();
  $materialsGroup.find('.form-control').append('<div class="materials-cart">-</div>');

});

function updateMaterials() {
  
  var materials = new Array();
  $('.material').each(function() {
    var id = $(this).attr('data-id');
    var title = $(this).attr('data-title');
    var input = $(this).find('.qty').first();
    materials.push({
      id: id,
      title: title,
      qty: parseFloat(input.val())
    });
    if (parseFloat(input.val())) {
      $(this).addClass('s_active');
    } else {
      $(this).removeClass('s_active');
    }
  });
  
  console.log(materials);
  
  var list = '';
  var sep = '';
  var html = '<table>';
  var totalItems = 0;
  var totalQty = 0;
  for (var i=0; i<materials.length; i++) {
    if (materials[i].qty) {
      list += sep + materials[i].qty + '   x   ' + materials[i].title;
      sep = "\n";
      html += '<tr>';
      html += '<td>' + materials[i].title + '</td>';
      html += '<td width="5%">x</td>';
      html += '<td width="10%" style="text-align: right;">' + materials[i].qty + '</td>';
      html += '</tr>';
      totalItems += 1;
      totalQty += materials[i].qty;
    }
  }
  html += '</table>';
  
  $('#form-group-materials .materials-cart').html(html);
  $('#form-group-materials textarea').val(list);
  
  var plural = '';
  if (totalItems > 1) plural = 's';
  $('.cart [data-id="cartText"]').text(totalItems + ' item' + plural + ' selected');
  if (totalItems) {
    $('.cart').addClass('s_active');
  } else {
    $('.cart').removeClass('s_active');
  }
  
}

$(document).on('change blur','.material .qty',function(){
  updateMaterials();
});

// quantity field custom value
$(document).on('change','.qty-select',function(){
  var $group = $(this).parents('.form-group');
  var $select = $group.find('.qty-select');
  if ($select.val() == 'more') {
    var fieldName = $select.attr('name');
    var fieldId = $select.attr('id');
    var newField = '<input type="number" name="' + fieldName + '" id="' + fieldId + '" value="0" class="card-form-input qty qty-input">';
    $select.after(newField);
    $select.remove();
    $group.find('.qty-input').focus().select();
  }
});

function filterMaterials() {
  
  var topic = '';
  if ($('.techfilterbtn.s_active').length) {
    topic = $('.techfilterbtn.s_active').attr('data-id');
  }
  
  $('.material').hide();
  if (topic.length) {
    $('.material[data-topics*="|' + topic + '|"]').show();
  } else {
    $('.material').show();
  }
  
}

$(document).on('click','.techfilterbtn',function(){
  $('.techfilterbtn').removeClass('s_active');
  $(this).addClass('s_active');
  filterMaterials();
  return false;
});

function handleMaterialsScroll() {

  var scrollY = window.pageYOffset || document.documentElement.scrollTop;
  var windowHeight = $(window).height();

  if ($('[data-id="details"]').length) {
    if ((scrollY + windowHeight / 2) > $('[data-id="details"]').offset().top) {
      $('.cart').addClass('s_hidden');
    } else {
      $('.cart').removeClass('s_hidden');
    }
  }

}

window.addEventListener('scroll', handleMaterialsScroll);
handleMaterialsScroll();
